/* istanbul ignore file */
/* eslint-disable import/prefer-default-export */

// Breakpoints
// TODO: look into adding to theme
// https://medium.flatstack.com/how-to-make-media-queries-strings-in-styled-components-shorter-and-more-reliable-c78bcce13fc8

const SCREEN_XS = 480;
const SCREEN_SM = 768;
const SCREEN_MD = 992;
const SCREEN_LG = 1200;
const SCREEN_XL = 1440;

const MOBILE_XS = `@media (max-width: ${SCREEN_XS - 1}px)`;
const MOBILE = `@media (max-width: ${SCREEN_SM - 1}px)`;
const TABLET = `@media (min-width: ${SCREEN_SM}px) and (max-width: ${SCREEN_MD - 1}px)`;
const DESKTOP = `@media (min-width: ${SCREEN_MD}px)`;
const DESKTOP_LG = `@media (min-width: ${SCREEN_LG}px)`;
const DESKTOP_XL = `@media (min-width: ${SCREEN_XL}px)`;

const EXCLUDE_MOBILE_XS = `@media (min-width: ${SCREEN_XS + 1}px)`;
const EXCLUDE_MOBILE = `@media (min-width: ${SCREEN_SM}px)`;
const EXCLUDE_TABLET = `@media (max-width: ${SCREEN_XS - 1}px) and (min-width: ${SCREEN_MD}px)`;
const EXCLUDE_DESKTOP = `@media (max-width: ${SCREEN_MD - 1}px)`;
const EXCLUDE_DESKTOP_LG = `@media (max-width: ${SCREEN_LG - 1}px)`;
const EXCLUDE_DESKTOP_XL = `@media (max-width: ${SCREEN_XL - 1}px)`;

const MEDIA_QUERY = {
  MOBILE_XS,
  MOBILE,
  TABLET,
  DESKTOP,
  DESKTOP_LG,
  DESKTOP_XL,
  EXCLUDE_MOBILE_XS,
  EXCLUDE_MOBILE,
  EXCLUDE_TABLET,
  EXCLUDE_DESKTOP,
  EXCLUDE_DESKTOP_LG,
  EXCLUDE_DESKTOP_XL,
  NOT_MOBILE: EXCLUDE_MOBILE, // deprecated
};

export default MEDIA_QUERY;
